var _path, _path2, _path3, _path4, _circle, _path5, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1002,
    height: 545,
    viewBox: "0 0 1002 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34 79C34 65.7452 44.7452 55 58 55H518V545H58C44.7452 545 34 534.255 34 521V79Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M518 55H978C991.255 55 1002 65.7452 1002 79V521C1002 534.255 991.255 545 978 545H518V55Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327 1.5C233 97.5 390.5 126.74 494 213.5C550.5 260.862 546.5 374 467 410.5C319.281 478.321 80.5 314.5 3 515",
    stroke: "#829FB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444 167.216C444 172.088 439.504 178.448 436.692 183.942C435.086 187.081 433.835 189.938 432.964 192.073C432.46 193.309 430.54 193.309 430.036 192.073C429.165 189.938 427.914 187.081 426.308 183.942C423.496 178.448 419 172.088 419 167.216C419 159.917 424.596 154 431.5 154C438.404 154 444 159.917 444 167.216Z",
    fill: "#957AFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 431,
    cy: 167,
    r: 7,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M303 58.2159C303 63.0879 298.504 69.4477 295.692 74.9423C294.086 78.0813 292.835 80.9379 291.964 83.0734C291.46 84.3089 289.54 84.3089 289.036 83.0734C288.165 80.9379 286.914 78.0813 285.308 74.9423C282.496 69.4477 278 63.0879 278 58.2159C278 50.917 283.596 45 290.5 45C297.404 45 303 50.917 303 58.2159Z",
    fill: "#957AFE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 58,
    r: 7,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBg);
export default __webpack_public_path__ + "static/media/header_bg.afd4152e8c1b2933a7d95b79736994c4.svg";
export { ForwardRef as ReactComponent };